import React from 'react';
import lg from '../assets/amawta_lp.png';

import {
  AppBar,
  Toolbar,
  Box,
  useMediaQuery,
} from '@mui/material';

import { useTheme } from '@mui/material/styles';

const NavBar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


  return (
    <>
      <AppBar position="sticky" sx={{ backgroundColor: '#031A7F' }}>
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          {/* LOGO + MENÚ */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <img
                src={lg}
                alt="Logo"
                style={{ display: 'block',height:"24px", width:"auto"}}
              />
            </Box>


            {/* MENÚ DESKTOP */}
            {!isMobile && (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>

              </Box>
            )}
          </Box>

        </Toolbar>
      </AppBar>

    </>
  );
};

export default NavBar;
